export enum ApiHeaders {
  tenant = 'AC-TENANT-ID',
  property = 'AC-PROPERTY-ID',
  subsidiary = 'AC-SUBSIDIARY-ID',
  ifmatch = 'IF-MATCH',
  contentType = 'CONTENT-TYPE',
  acceptLanguage = 'ACCEPT-LANGUAGE'
}



// WEBPACK FOOTER //
// ./src/shared/enum/Headers.ts